import { useCallback, useContext } from 'react'

import { QuickSearchContext } from '@/providers/QuickSearchContextProvider'

export const useQuickSearchReset = () => {
  const { setSearchText } = useContext(QuickSearchContext)

  const reset = useCallback(() => {
    setSearchText('')
  }, [setSearchText])

  return {
    reset,
  }
}
